export default {
  "custom": {
    linkedReference: 'Referência vinculada',
    boot: 'Ligar',
    shutDown: 'Desligar',
    notLinked: 'Não vinculado',
    maxLinkedTip: 'Máximo de 2 vinculações de {type} permitido, revertido automaticamente para Não vinculado',

    bar_Power: 'Energia',
    bar_Video: 'Troca de vídeo',
    bar_Vol: 'Volume',
    bar_Audio: 'Troca de áudio',
    bar_Serial: 'Controle serial',
    bar_Air: 'Ar-condicionado',
    bar_Projection: 'Tela de projeção',
    bar_Remote: 'Controle remoto',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'Você deve selecionar as três imagens ao mesmo tempo',
    notSelected: 'Não selecionado',
    choose: 'Escolher',
    disable: 'Desativar',
    "longPressAndDrag": "Pressione e segure, depois arraste para ajustar a ordem da lista",
    "isrestoreDefault": "Deseja restaurar para o estado padrão?",
    "saveAndSync": "Salvar e sincronizar",
    "restoreDefault": "Restaurar padrão",
    "limitPNG": "Somente imagens PNG podem ser carregadas!",
    "limit1M": "O tamanho da imagem não pode exceder 1 MB!",
    "selectTheImage": "Selecionar imagem",
    "textsuggestions": "Recomendado: ícone PNG branco 48*48 px, menor que 1 MB",
    "iconLibrary": "Biblioteca de ícones",
    "panelNavigationBarCustomization": "Barra de navegação do painel",
    "logoCustomization": "Logo do painel"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'Falha na vinculação: este locatário da Microsoft (ID: ',
    AuthVerify4004Two: ') já está ocupado pela organização [',
    AuthVerify4004Three: ']. Para vincular novamente, primeiro desvincule-o da organização original ou use outro locatário da Microsoft.',
    theMicrosoftTenantIsOccupied: 'O locatário da Microsoft está ocupado',
    Viewtutorial: "Ver tutorial de vinculação",
    checktenantID: "Por favor, verifique se o seu ID de inquilino, ID de aplicação e chave de aplicação estão corretos.",
    ErrorCode: "Código de erro:",
    AuthorizationFailed: "Autorização falhada",
    Accesshasbeengranted: "Foi concedido acesso à API Microsoft Graph",
    successfullyauthorizedDescribe: "As permissões necessárias foram autorizadas com sucesso. Os dados da sala de reuniões serão sincronizados automaticamente. Por favor, feche esta página.",
    Close: "Fechar",
    resourceID: "ID de recurso",
    dialogTips: "Dicas",
    theAuthorizationIsDeleted: "Autorização removida",
    theBindingIsSuccessful: "Vinculação bem-sucedida",
    theUnbindingIsSuccessful: "Desvinculação bem-sucedida",
    unbindingFailed: "Falha na desvinculação",
    theUnbindingHasBeenUnbound: "Desvinculação cancelada",
    continueUnbinding: "A sincronização com o Outlook será interrompida e todos os eventos futuros serão apagados. Continuar com a desvinculação?",
    areYouSureAboutUnbinding: "Todos os eventos futuros do Outlook serão apagados e a sincronização será interrompida. Esta ação não pode ser desfeita. Confirmar desvinculação?",
    UnbindNotSynchronized: "Após vinculação, novos eventos do Outlook para esta sala serão sincronizados automaticamente (eventos passados não serão sincronizados)",
    unbinding: "Desvincular",
    bindUnableToSelect: "Já vinculado, não é possível selecionar",
    permissAThird: "Por favor, autorize a vinculação de recursos de terceiros",
    resourceMailbox: "Mailbox de recurso:",
    PleasecheckID: "Autorização falhada! Por favor, verifique se o seu ID de inquilino, ID de aplicação e segredo do cliente estão corretos.",
    Waitingforauthorization: "À espera de autorização...",
    Pleasecompletetheauthorization: "Página de login do Microsoft 365 aberta. Por favor, inicie sessão com uma conta de administrador para completar a autorização.",
    pleaseEnterTheTenantID: "Por favor, introduza o ID de inquilino",
    pleaseEnterTheClientID: "Por favor, introduza o ID de aplicação",
    pleaseEnterTheClientSecret: "Por favor, introduza o segredo do cliente",
    Authorizationcompleted: "Autorização concluída",
    Authorizelogin: "Autorizar login Microsoft 365",
    ApplicationID: "ID de inquilino",
    ClientID: "ID de aplicação",
    ClientSecret: "Segredo do cliente",
    registTipOne: "Por favor, siga o",
    registTipTwo: "Guia de vinculação",
    registTipThree: "Complete o registo da aplicação Azure e configurações de permissões antes de preencher os campos abaixo.",
    MicrosoftDescribe: "Ao vincular com o Microsoft 365, as reuniões marcadas no Outlook/Teams serão automaticamente sincronizadas com a Consola Q-NEX e o Agendador de Salas.",
    Addcalendarservice: "Definições de sincronização de calendário",
    Lasttimesynchronization: "Última sincronização",
    Allocated: "Atribuído",
    Total: "Total",
    Conferenceroomresources: "Recursos de sala de reuniões",
    Bindingtime: "Hora de vinculação",
    Bindtheplatform: "Plataforma de vinculação",
    Synchronousstate: "Estado de sincronização",
    Organizationname: "Nome da organização",
    Bindthirdpartycalendar: "Vincular calendário de terceiros",
    TenantIDTip: "Identificador único no Azure AD",
    ApplicationIDTip: "ID de aplicação registado no Azure",
    ApplicationSecretTip: "Segredo do cliente gerado no Azure para autenticação"
  },
  "meetingManager": {
    IdleDisplayTextTable: 'Texto de exibição em espera',
    IdleDisplayText: 'Texto de exibição em espera:',
    IdleDisplayTextContent: 'Texto exibido quando a sala está vazia (padrão: “Livre”)',

    duplicateMeetingRoomName: 'Nome da sala de reunião duplicado',
    duplicateMeetingRoomNameContent: 'Já existe uma sala de reunião chamada "{duplicate_content}". Insira outro nome.',
    NumberOfRoomPanels: 'Número de painéis da sala',
    "Thecurrentterminalhasbeenboundtoanotherorganization": " O terminal atual já está vinculado a outra organização.",
    "theTerminalNameOrIDIsDuplicated": "O nome ou ID do painel é o mesmo",
    theRoomNameOrIDIsDuplicated: 'O nome da sala de reunião ou o local já existe.',
    "AddMeetingRoom": "Adicionar sala de reuniões",
    "EditMeetingRoom": "Editar sala de reuniões",
    "MeetingRoomName": "Nome da sala de reuniões:",
    "Location": "Localização:",
    "ReservationApproval": "Aprovação da reserva:",
    "ApprovalListYes": "sim",
    "ApprovalListNo": "não",
    "Capacity": "Capacidade:",
    "RoomStatus": "Status da sala:",
    "BindRoomDisplay": "Vincular painel da sala:",
    "meeting_btnAdd": "Adicionar",
    "meeting_btnEdit": "Editar",
    "meeting_btnBind": "Vincular dispositivo",
    "meeting_btnDel": "Excluir",
    "meeting_tableRoomName": "Nome da sala de reuniões",
    "meeting_tableRoomPlace": "Localização",
    "meeting_tableAppointmentApproval": "Aprovação da reserva",
    "meeting_tableCapacityForPeople": "Capacidade",
    "meeting_tableMeetingRoomStatus": "Status da sala",
    "meeting_tableAvaliable": "Disponível",
    "meeting_tableOutofService": "Fora de serviço",
    "meeting_tableDoorBind": "Vincular porta",
    "meeting_tableBindNPS": "Vincular NPS",
    "meeting_tableActions": "Ações",
    "door_theNameOfTheTerminal": "Nome do painel:",
    "door_deviceID": "ID do painel:",
    "door_Wallpaper": "Papel de parede:",
    "door_Wallpaper_text": "Imagem recomendada: tamanho 1280x800, no formato PNG",
    "door_bindAMeetingRoom": "Vincular sala de reuniões:",
    "door_table_name": "Nome do painel",
    "door_table_deviceID": "ID do painel",
    "door_table_status": "Status",
    "door_table_ipAddress": "Endereço IP",
    "door_table_bindAMeetingRoom": "Vincular sala de reuniões",
    "door_btnAdd": "Adicionar",
    "door_btnBatchAdd": "Adicionar em lote",
    "door_btnEdit": "Editar",
    "door_btnBatchEdit": "Editar em lote"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "Adicionar configuração",
    "configurationEditTitle": "Editar configuração",
    "dialogConfigName": "Nome da configuração",
    "selectNMPAndNDP": "Dispositivos de destino",
    "powerControl": "Controle de energia",
    "executeCommand": "Fazer",
    "tableConfigName": "Nome da configuração",
    "selectConfig": "Por favor, selecione a configuração"
  },
  "NPS": {
    "Relay": "Relé",
    "RelaySettings": "Configurações do relé",
    "DevicePower": "Controle de energia do dispositivo",
    "DeviceElevation": "Controle de elevação",
    "LinageWithNPSPower": "Link com a alimentação NPS",
    "PresentationSwitch": "Interruptor de apresentação",
    "Duplicate": "Duplicar",
    "LinkagewithNPSPowe": "Link com a alimentação NPS"
  },
  "PTZ": {
    "powerSupplyON": "Ligar",
    "powerSupplyOFF": "Desligar",
    "LEFT": "Esquerda",
    "RIGHT": "Direita",
    "UP": "Cima",
    "DOWN": "Baixo",
    "HOME": "Início",
    "ENLARGE": "Aumentar",
    "REDUCTION": "Reduzir",
    "StopMovement": "Parar movimento",
    "STOP": "Parar zoom",
    "FOCUS": "Foco",
    "SET_PRESETS0": "AJUSTAR_PRESET0",
    "SET_PRESETS1": "AJUSTAR_PRESET1",
    "SET_PRESETS2": "AJUSTAR_PRESET2",
    "SET_PRESETS3": "AJUSTAR_PRESET3",
    "SET_PRESETS4": "AJUSTAR_PRESET4",
    "SET_PRESETS5": "AJUSTAR_PRESET5",
    "SET_PRESETS6": "AJUSTAR_PRESET6",
    "SET_PRESETS7": "AJUSTAR_PRESET7",
    "SET_PRESETS8": "AJUSTAR_PRESET8",
    "SET_PRESETS9": "AJUSTAR_PRESET9",
    "USE_PRESETS0": "USAR_PRESET0",
    "USE_PRESETS1": "USAR_PRESET1",
    "USE_PRESETS2": "USAR_PRESET2",
    "USE_PRESETS3": "USAR_PRESET3",
    "USE_PRESETS4": "USAR_PRESET4",
    "USE_PRESETS5": "USAR_PRESET5",
    "USE_PRESETS6": "USAR_PRESET6",
    "USE_PRESETS7": "USAR_PRESET7",
    "USE_PRESETS8": "USAR_PRESET8",
    "USE_PRESETS9": "USAR_PRESET9"
  },
  "schedule": {
    "startLinkPowerStart": "Ligar (Relé CBXs)  ",
    "startLinkPowerStop": "Desligar (Relé CBXs)  ",
    "dehumidification": "Seco  ",
    "airSupply": "Ventilador  ",
    "masterControl": "principal:  ",
    "powerSupply": "Energia  ",
    "lockScreen": "Bloqueio  ",
    "RecordingControl": "Controle de gravação  ",
    "RecordingControlSystem": "Sistema de captura de aula  ",
    "LiquidCrystal": "Painel interativo de tela plana  ",
    "projector": "Projetor  ",
    "othertype": "Outro  ",
    "childLock": "Bloqueio infantil  ",
    "energySaving": "Economia de energia  ",
    "signalSourceSwitching": "Fonte de entrada  ",
    "other": "Outras funções:  ",
    "otherFunction": "Função  ",
    "send": "Enviar  ",
    "ON": "LIGAR  ",
    "OFF": "DESLIGAR  ",
    "btnAddSchedule": "Restaurar  ",
    "EditSchedulelist": "Editar agendador  ",
    "AddSchedulelist": "Adicionar agendador  ",
    "RestoreSchedulelist": "Restaurar  ",
    "btn": "Cancelar  ",
    "btnNewList": "Novo agendador  ",
    "ListName": "Nome  ",
    "Cannotquit": "Obrigatório  ",
    "NOCannotquit": "NÃO  ",
    "ListValidityPeriod": "Período de validade  ",
    "ListDescription": "Descrição  ",
    "currentSchedule": "Lista de agendadores  ",
    "historySchedule": "Lista de histórico  ",
    "selectTime": "Hora  ",
    "taskType": "Tipo de tarefa  ",
    "selectBroadcasting": "Transmissão  ",
    "selectDeviveControl": "Controle de dispositivo  ",
    "newSchedule": "Nova tarefa  ",
    "newChecklist": "Nova lista de verificação  ",
    "titleStatus": "Status  ",
    "titleType": "Tipo  ",
    "titleStartTime": "Hora de início  ",
    "titleEndTime": "Hora de término  ",
    "titleRepeat": "Repetir  ",
    "titleName": "Nome  ",
    "titleAction": "Ação  ",
    "tableEnabled": "Ativado  ",
    "tablePaused": "Pausado  ",
    "tableEdit": "Editar  ",
    "tableDelete": "Excluir",
    "tableVolumeEdit": "Volume de transmissão  ",
    "tableBroadcastTitle": "Título  ",
    "tableBroadcastContent": "Conteúdo  ",
    "tableBroadcastList": "Lista  ",
    "tableBroadcast": "Compulsivo  ",
    "btnRemoveCompletely": "Remover completamente  ",
    "btnEnabled": "Ativado  ",
    "btnPaused": "Pausado  ",
    "btnDelete": "Excluir  ",
    "repeat0": "SEG  ",
    "repeat1": "TER  ",
    "repeat2": "QUA  ",
    "repeat3": "QUI  ",
    "repeat4": "SEX  ",
    "repeat5": "SÁB  ",
    "repeat6": "DOM  ",
    "dialogTitleAdd": "Nova tarefa de controle de dispositivo  ",
    "dialogTitleEdit": "Editar tarefa de controle de dispositivo  ",
    "newBroadcastingSchedule": "Nova tarefa de transmissão  ",
    "editBroadcastingSchedule": "Editar tarefa de transmissão  ",
    "chooseDevice": "Escolher dispositivo  ",
    "timeSetting": "Configuração de horário  ",
    "controlBroadcasting": "Opção de transmissão  ",
    "controlOption": "Opção de controle  ",
    "scheduleName": "Nome da tarefa:  ",
    "destination": "Destino  ",
    "timeTilte": "Hora  ",
    "repeatTitle": "Repetir  ",
    "dialogRepeat0": "SEG  ",
    "dialogRepeat1": "TER  ",
    "dialogRepeat2": "QUA  ",
    "dialogRepeat3": "QUI  ",
    "dialogRepeat4": "SEX  ",
    "dialogRepeat5": "SÁB  ",
    "dialogRepeat6": "DOM  ",
    "dialogOnceType": "Uma vez  ",
    "dialogRepeatType": "Repetir  ",
    "mainPower": "Energia principal  ",
    "powerControl": "Controle de energia  ",
    "tableDisplayInputSwitch": "Interruptor de entrada de exibição  ",
    "tableAirConditioning": "Ar condicionado  ",
    "tableProjectionScreen": "Tela de projeção  ",
    "tableElectronicLock": "Fechadura elétrica  ",
    "interactiveFlatPanel": "Painel interativo de tela plana  ",
    "displayInputSwitch": "Interruptor de entrada de exibição  ",
    "speakerVolume": "Volume dos alto-falantes  ",
    "MICVolume": "Volume do microfone  ",
    "ProjectionScreen": "Tela de projeção  ",
    "ElectronicLock": "Fechadura elétrica  ",
    "AirConditioning": "Ar condicionado",
    "AirConditioningPower": "Potência  ",
    "AirConditioningModel": "Modelo  ",
    "AirConditioningTEMP": "TEMP  ",
    "AirConditioningFanSpeed": "Velocidade do ventilador  ",
    "OPEN": "ABRIR  ",
    "CLOSE": "FECHAR  ",
    "UP": "CIMA  ",
    "DOWN": "BAIXO  ",
    "PowerOFF": "DESLIGADO  ",
    "PowerON": "LIGADO  ",
    "ModelAuto": "Automático  ",
    "ModelCool": "Resfriar  ",
    "ModelHeat": "Aquentar  ",
    "ModelAir": "Lado do ar  ",
    "TEMPLow": "Baixo  ",
    "TEMPMiddle": "Médio  ",
    "TEMPHigh": "Alto  ",
    "btnSave": "Salvar  ",
    "btnNext": "PRÓXIMO  ",
    "StartTime": "Hora de início  ",
    "StopTime": "Hora de término  ",
    "Mandatory": "Obrigatório  ",
    "Video": "Vídeo & Áudio  ",
    "Notification": "Notificação  ",
    "btnFile": "Selecione um arquivo de mídia  ",
    "LastingTime": "Duração  ",
    "textTitle": "Título  ",
    "textContent": "Conteúdo  ",
    "textTitleLetters": "Menos de 60 caracteres  ",
    "textContentLetters": "Menos de 320 caracteres  ",
    "CannotquitYES": "SIM  ",
    "CannotquitNo": "Não  ",
    "YES": "SIM  ",
    "No": "Não  ",
    "delTitleContent": "Tem certeza de que deseja excluir este agendador?  ",
    "delTitleListContent": "O agendador excluído será movido para a lista de histórico e poderá ser restaurado  ",
    "deleListTitle": "Excluir o agendador?  ",
    "delTitleListContent1": "Excluir o agendador fará com que as tarefas associadas a ele sejam apagadas, por favor, confirme.  ",
    "deleListTitle1": "Tem certeza de que deseja excluir este agendador?  ",
    "delTitle": "Excluir?  ",
    "btnConfirm": "Confirmar  ",
    "coxAll": "TODOS  ",
    "coxBroadcasting": "Transmissão  ",
    "coxDeviveControl": "Controle de Dispositivos  ",
    "rdMandatory": "SIM  ",
    "noRdMandatory": "NÃO  ",
    "startDate": "Data de início  ",
    "endedDate": "Data de término  ",
    "or": "-  ",
    "broadcastingType": "Tipo",
    "ChooseTime": "Escolher hora  ",
    "ChooseDate": "Escolher data  ",
    "newScheduleList": "Novo programador  ",
    "editScheduleList": "Editar programador  ",
    "listName": "Nome  ",
    "listValidityPeriod": "Período de validade  ",
    "listDescription": "Descrição  ",
    "cancel": "Cancelar  ",
    "confirm": "Confirmar  ",
    "save": "Salvar  ",
    "addSuccess": "Adicionado com sucesso!  ",
    "addError": "Falha ao adicionar!  ",
    "editSuccess": "Editado com sucesso!  ",
    "editError": "Falha ao editar!  ",
    "delSuccess": "Deletado com sucesso!  ",
    "delError": "Falha ao deletar!  ",
    "restoreSuccess": "Lista de programadores restaurada com sucesso  ",
    "restoreError": "Falha ao recuperar lista de programadores  ",
    "restoreTitleContent": "Este horário entra em conflito com o horário na lista, por favor selecione novamente  ",
    "Enabled": "Ativado  ",
    "Paused": "Pausado  ",
    "Title": "Título:  ",
    "Content": "Conteúdo:  ",
    "errorScheduleNameRequired": "O nome da tarefa deve ser preenchido  ",
    "errorDeviceRequired": "Por favor, selecione o dispositivo de destino  ",
    "deleTitle": "Tem certeza de que deseja excluir esta tarefa?  ",
    "loopList": "Lista de repetição  ",
    "errorPleaseDateRange": "Por favor, selecione um intervalo de datas  ",
    "addError_2009": "Nome de programador duplicado  ",
    "conflicts": "O tempo da tarefa entra em conflito com os seguintes:  ",
    "Pleaseagain": "Por favor, insira novamente  ",
    "errorScheduleName": "Nome da tarefa  ",
    "errorListName": "Nome do programador  ",
    "today": "Hoje  ",
    "yesterday": "Ontem  ",
    "thisWeek": "Esta semana  ",
    "lastWeek": "Semana passada  ",
    "lastMonth": "Mês passado  ",
    "thisMonth": "Este mês  ",
    "times": "Vezes  ",
    "TimeConflicts": "Conflitos de tempo  ",
    "editError_2006": "Dispositivo não encontrado  ",
    "editError_2010": "Nome da tarefa duplicado  ",
    "ListTimeExpired": "O tempo do programador expirou, por favor selecione novamente  ",
    "TimeExpired": "Tempo expirado  ",
    "ControlOption": "Falta a opção de controle  ",
    "Pleaseleastone": "Por favor, selecione pelo menos uma opção de controle  ",
    "Enter": "Entrar  ",
    "TitleFilled": "O título deve ser preenchido  ",
    "ContentFilled": "O conteúdo deve ser preenchido  ",
    "PleaseMediaFile": "Por favor, selecione um arquivo de mídia  ",
    "PleaseSchedule": "Por favor, selecione uma tarefa  ",
    "delTitleScheduleContent": "A tarefa excluída não pode ser recuperada.  ",
    "deleTitleSchedule": "Você tem certeza de que deseja excluir esta tarefa?  ",
    "deleteScheduleTitle": "Por favor, selecione a tarefa para excluir  ",
    "PleaseFillColumn": "Por favor, preencha o nome do programador  ",
    "PleaseDate": "Por favor, selecione a data  ",
    "Previous": "Anterior  ",
    "RemoteControl": "Controle remoto  ",
    "taskhasexpired": "Esta tarefa expirou, entre em contato com o criador para atualizar o horário.  ",
    "execute": "Executar  ",
    "broadcastingList": "Lista de transmissão  ",
    "volumeSuccess": "Volume ajustado com sucesso  ",
    "volumeFailed": "Falha ao ajustar o volume  "
  },
  "Automation": {
    "nameDuplicate": "Nome da tarefa duplicado automaticamente  ",
    "Automation": "Automação  ",
    "if": "Se:  ",
    "ifContent": "A seção 'SE' permite definir condições com base nos dados do sensor. Escolha o sensor e defina condições como 'Temperatura > 26°C'.  ",
    "then": "Então:  ",
    "thenContent": "A seção 'ENTÃO' permite escolher dispositivos e definir ações para eles. Selecione dispositivos como NMP1, NMP2 e defina ações como 'Ligar + Resfriar' para os ares-condicionados.  ",
    "btnDelete": "Excluir  ",
    "Add": "Adicionar  ",
    "taskName": "Nome da tarefa  ",
    "dialogTaskName": "Nome da tarefa:  ",
    "Statue": "Status  ",
    "DevicesApplied": "Dispositivos aplicados  ",
    "Operation": "Operação  ",
    "AirConditioningPower": "Energia  ",
    "AirConditioningModel": "Modelo  ",
    "AirConditioningFanSpeed": "Velocidade do ventilador  ",
    "bold": "Oscilação  ",
    "selectTask": "Selecione a tarefa  ",
    "autoTaskAdd": "Adicionar tarefa de automação  ",
    "autoTaskEdit": "Editar tarefa de automação  ",
    "Destination": "Destino  ",
    "selectConditions": "Por favor, especifique a ação que deseja realizar.  ",
    "selectDestination": "Selecione o(s) dispositivo(s) de destino NMP, depois especifique a ação que deseja realizar  ",
    "AirConditioningTEMP": "Temperatura  ",
    "AirConditioningHumidness": "Umidade  ",
    "noData": "Nenhuma tarefa adicionada ainda. Clique no botão \"Adicionar\" para adicionar tarefas.  "
  },
  "rs232Translation": {
    "reliveBinding": "Desvincular  ",
    "RELIVEBINDING": "Desvincular",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "O nome do CBX não pode estar vazio  ",
    "BrandNoNull": "A marca não pode estar vazia  ",
    "ModelNoNull": "O modelo não pode estar vazio  ",
    "AcNoNull": "O controle de A/C não pode estar vazio  ",
    "RcNoNull": "O controle remoto não pode estar vazio"
  },
  "route": {
    customize: 'Personalizar',
    "InputSourcesLinkage": "Vinculação de fontes de entrada  ",
    "Automation": "Automação  ",
    "dashboard": "Dashboard",
    "i18n": "I18n  ",
    "organizationMge": "Grupos  ",
    "userMge": "Usuários  ",
    "authorityMge": "Permissão  ",
    "roleMge": "Funções  ",
    "equipmentMge": "Dispositivos  ",
    "workstationMge": "Mídia ",
    "cloudDiskMge": "Armazenamento",
    "operationLog": "Registro de operações  ",
    "setting": "Configurações  ",
    "resourceMge": "Gestão de recursos  ",
    "storageMge": "Gestão de armazenamento  ",
    "interfaceRename": "Renomear interface  ",
    "processorManager": "Gerenciador de processador  ",
    "projectorCode": "Gerenciamento de código de série  ",
    "projectorCodeSetting": "Configurações de código de série  ",
    "RepairLog": "Registro de reparos  ",
    "remoteControl": "Código de controle remoto  ",
    "acCode": "Código de controle de ar condicionado  ",
    "cardMge": "Cartões  ",
    "cardLog": "Registro de uso de cartões  ",
    "cardManager": "Gerenciador de cartões  ",
    "meetingManager": "Reunião  ",
    "meetingRoomManager": "Gestão de salas  ",
    "meetingDoorManager": "Gestão de painéis"
  },
  "navbar": {
    "logOut": "Sair  ",
    "dashboard": "Painel de controle  ",
    "screenfull": "Tela cheia  ",
    "language": "Idioma  ",
    "userConsole": "Console Q-NEX  ",
    "BackTianwa": "Voltar para Tianwa"
  },
  "feedback": {
    "Feedback": "Comentários  ",
    "email": "Por favor, deixe seu e-mail para nosso retorno.  ",
    "content": "Bem-vindo e deixe mensagens para melhorar nossos produtos. Obrigado pelos seus comentários.  ",
    "submit": "Enviar  ",
    "emailNoEmpty": "O e-mail não pode estar vazio  ",
    "emailTrueRule": "Por favor, insira o formato de e-mail correto  ",
    "contentNoEmpty": "O conteúdo não pode estar vazio  ",
    "feedbackSuccess": "Comentário bem-sucedido  ",
    "feedbackFailed": "Falha no comentário  ",
    "emailNoChinese": "A caixa de entrada não pode conter caracteres chineses  ",
    "emailLength": "Entre 5 e 100 caracteres de comprimento  ",
    "GroupNameLength": "Entre 1 e 20 caracteres de comprimento  ",
    "emailSpecialString": "Este campo de entrada não pode conter strings especiais"
  },
  "login": {
    "title": "BEM-VINDO  ",
    "logIn": "Entrar  ",
    "username": "Nome de usuário  ",
    "password": "Senha  ",
    "any": "qualquer  ",
    "thirdparty": "Ou conecte-se com  ",
    "thirdpartyTips": "Não é possível simular localmente, então, por favor, combine sua própria simulação de negócios!!!  ",
    "placeholder": "[  \n  \"Nome de usuário\",  \n  \"Senha\",  \n  \"Código de verificação\"  \n]  ",
    "userNameTitle": "Nome de usuário incorreto!  ",
    "forget": "Esqueceu?  ",
    "loginTitle0": "Login bem-sucedido!  ",
    "loginTitle1000": "Nome de usuário ou senha incorretos!  ",
    "loginTitle1001": "Nome de usuário e senha devem ser preenchidos!  ",
    "loginTitle1002": "O código de verificação deve ser preenchido!  ",
    "loginTitle1003": "O status do usuário é ilegal, falha no login!  ",
    "loginTitle1004": "Erro no código de verificação!  ",
    "loginTitle1005": "Não está logado, faça login primeiro!  ",
    "loginTitleUserName": "Nome de usuário deve ser preenchido!  ",
    "loginTitlePwd": "Senha deve ser preenchida!  ",
    "loginTitleVercode": "O código de verificação deve ser preenchido!  ",
    "errorLogin": "Direitos de usuário insuficientes, não é possível fazer login!  ",
    "titleLoginNameFormat": "Deve consistir em caracteres ou caracteres e números."
  },
  "organizationMge": {
    "CanTDragTop": "Não é possível mover para a raiz  ",
    "prefixCannotBeEmpty": "O prefixo da conta de superadministrador não pode estar vazio  ",
    "enterEnglishLetters": "O prefixo da conta de superadministrador só pode conter letras e números em inglês  ",
    "dateNotSelected": "A data de início do período de validade do serviço de streaming não foi selecionada  ",
    "btnAddChild": "Adicionar subordinado  ",
    "btnAddSibling": "Adicionar irmão  ",
    "title": "Dica:  ",
    "againTitle": "Por favor, confirme novamente:  ",
    "sort": "Ordenar:  ",
    "realName": "Nome real:  ",
    "titleShooleRq": "Este campo deve ser preenchido  ",
    "titleShooleNub": "menos de 100 caracteres  ",
    "schoolName": "Nome do grupo:  ",
    "type": "Tipo de grupo:  ",
    "accountPrefix": "Conta de administrador:  ",
    "organization": "Distribuidor  ",
    "terminalMechanism": "Usuário final  ",
    "equipmentNum": "Número do dispositivo:  ",
    "organizationNum": "Número de grupos de terminais:  ",
    "adminName": "Conta de administrador:  ",
    "adminPwd": "Senha de administrador:  ",
    "edit": "Editar  ",
    "add": "Adicionar  ",
    "del": "Excluir  ",
    "addSuccess": "Adicionado com sucesso  ",
    "addError": "Falha ao adicionar!  ",
    "editSuccess": "Alterado com sucesso  ",
    "editError": "Falha ao modificar!  ",
    "delSuccess": "Excluído com sucesso!  ",
    "delWarn": "Não é possível excluir este grupo com dispositivos vinculados  ",
    "delError": "Falha ao excluir!  ",
    "cancel": "Cancelar  ",
    "confirm": "Confirmar  ",
    "save": "Salvar  ",
    "TrialWorkstation": "Você está atualmente no estado de teste e só pode transmitir e fazer streaming para no máximo 3 dispositivos terminais.  ",
    "Normal": "Normal  ",
    "NormalWorkstation": "O período de validade do seu serviço de streaming é de  ",
    "to": "até  ",
    "Advent": "Advento  ",
    "AdventWorkstationOne": "Seu serviço de streaming expirará em  ",
    "AdventWorkstationTwo": ", por favor, entre em contato com seu agente para renovar a tempo para uso normal.  ",
    "Expired": "Expirado  ",
    "ExpiredWorkstation": "Seu serviço de streaming expirou, por favor, entre em contato com seu agente para renová-lo a tempo.  ",
    "admin": "Administrador:  ",
    "serviceState": "Serviço de mídia de streaming:  ",
    "serviceStateLIST": "Serviço de mídia de streaming  ",
    "ValidityPeriod": "Período de validade:  ",
    "ValidityPeriodLIST": "Período de validade  ",
    "Trial": "Teste  ",
    "Permanent": "Permanente  ",
    "AnnualBilling": "Faturamento anual  ",
    "mediaValidityPeriod": "Período de validade:  ",
    "mediaValidityPeriodLIST": "Período de validade  ",
    "contactInformation": "Detalhes de contato (para lembrete de renovação do serviço de streaming)  ",
    "company": "Nome da empresa:  ",
    "email": "E-mail:  ",
    "phone": "Telefone:  ",
    "StartDate": "Data de início  ",
    "EndDate": "Data de término  ",
    "To": "Até  ",
    "TerminalName": "Nome do usuário final  ",
    "Competence": "Administrador  ",
    "operate": "Operar  ",
    "statusFilter": "Filtro de status  ",
    "disableStreaming": "Tem certeza de que deseja desativar o serviço de streaming?  ",
    "enableStreaming": "Tem certeza de que deseja ativar o serviço de streaming?  ",
    "disableStreamingContent": "Quando o serviço de streaming for desativado, o grupo não poderá usar as funções relacionadas à transmissão e transmissão ao vivo.  ",
    "enableStreamingContent": "Por favor, modifique o período de validade para os grupos com serviço de streaming expirado.  ",
    "search": "Digite o nome da organização  ",
    "optionsYearZero": "Por favor, escolha",
    "optionsYearOne": "Um ano  ",
    "optionsYearTwo": "Dois anos  ",
    "optionsYearThree": "Três anos  ",
    "dialogName": "Nome:  ",
    "detTitle": "Excluir o grupo fará com que todo o conteúdo abaixo dele seja excluído também.  ",
    "groupDelTitle": "Tem certeza de que deseja excluir este grupo?  ",
    "delTitle": "Excluir?  ",
    "delTitleContent": "O conteúdo selecionado será excluído do banco de dados. Esta operação não pode ser desfeita. Tem certeza de que deseja continuar?  ",
    "delCancelButton": "Cancelar  ",
    "delConfirmButton": "Confirmar  ",
    "copySuccess": "O conteúdo foi copiado para a área de transferência.  ",
    "copyError": "O navegador não suporta a cópia automática  ",
    "error1200": "Nome do grupo duplicado  ",
    "error1201": "Duplicação de grupo ou ID de grupo  ",
    "error1202": "Excedeu o número máximo de dispositivos conectáveis  ",
    "error1203": "Nome de usuário duplicado  ",
    "error1204": "Já existe um grupo com o mesmo nome no mesmo nível  ",
    "error1210": "Por favor, insira a senha do administrador  ",
    "warningGroup": "Escolha um grupo!  ",
    "warningTerminal": "O grupo terminal não pode criar subgrupos!  ",
    "account": "Conta duplicada  ",
    "titleOrganization": "NObservação: O prefixo da conta é definido no nível da organização. Todas as contas de usuário desta organização compartilharão o mesmo prefixo.",
    "all": "Tudo"
  },
  "userMge": {
    "nickName": "Apelido  ",
    "contentWithBrand": "Digite a marca ou o modelo  ",
    "contentwithIp": "Pesquisar por nome do dispositivo ou endereço IP.  ",
    "btnAdd": "Novo usuário  ",
    "btnDelete": "Excluir  ",
    "btnDownload": "Baixar modelo  ",
    "btnImport": "Importação em massa  ",
    "btnExport": "Baixar  ",
    "btnDisable": "Desabilitar  ",
    "btnEnable": "Habilitar  ",
    "accountType": "Filtrar por função  ",
    "organizationName": "Filtrar por grupo  ",
    "content": "Pesquisar  ",
    "systemAccount": "ID do usuário  ",
    "idCardNumber": "ID do funcionário  ",
    "customizeAccount": "Conta personalizada  ",
    "userName": "Nome  ",
    "licenseNum": "Número de licença  ",
    "phone": "Telefone  ",
    "email": "E-mail  ",
    "role": "Função  ",
    "status": "Status  ",
    "affiliatedOrganization": "Grupos  ",
    "roleTypeList1": "Usuário geral  ",
    "roleTypeList2": "Estudante  ",
    "roleTypeList3": "Pai  ",
    "roleTypeList101": "Agente Admin  ",
    "roleTypeList102": "Administrador  ",
    "roleTypeList301": "Super Admin  ",
    "userStatus1": "Ativo  ",
    "userStatus2": "Bloqueado  ",
    "userStatus3": "Excluir  ",
    "operate": "Ações  ",
    "dialogName": "Apelido:  ",
    "dialogUserName": "ID do usuário:  ",
    "dialogUserNameDefined": "Nome de usuário:  ",
    "dialogPassword": "Senha:  ",
    "dialogID": "ID do funcionário:  ",
    "dialogRole": "Função:  ",
    "dialogEmail": "E-mail:  ",
    "dialogPhone": "Telefone:  ",
    "dialogGroup": "Grupo:  ",
    "addUser": "Novo usuário  ",
    "editUser": "Editar usuário  ",
    "addSuccess": "Adicionado com sucesso!  ",
    "addError": "Falha ao adicionar!  ",
    "editSuccess": "Editado com sucesso!  ",
    "editError": "Falha ao editar!  ",
    "delSuccess": "Excluído com sucesso!",
    "delError": "Falha ao excluir!  ",
    "cancel": "Cancelar  ",
    "confirm": "Confirmar  ",
    "save": "Salvar  ",
    "tableDel": "Excluir  ",
    "tableEdit": "Editar  ",
    "selectRoles": "Selecionar funções  ",
    "delTitle": "Excluir?  ",
    "delTitleContent": "O conteúdo selecionado será excluído do banco de dados. Esta operação não pode ser desfeita. Tem certeza de que deseja continuar?  ",
    "delCancelButton": "Cancelar  ",
    "delConfirmButton": "Confirmar  ",
    "titleRealNameRq": "Este campo deve ser preenchido  ",
    "titleRealNameFormat": "Escolha um nome de usuário que contenha apenas letras e números.  ",
    checkPasswordTitleTwo: 'Defina uma senha com pelo menos 6 caracteres, incluindo letras e números. Caracteres especiais são permitidos (sem restrições).',
    checkPasswordTitle: 'A senha deve ter pelo menos 6 caracteres e não pode ser apenas números',
    "titlePhoneFormat": "O telefone só pode conter números, (), + e -.  ",
    "phoneFilled": "O telefone deve ser preenchido.  ",
    "titleEmaileFormat": "Erro no formato do e-mail.  ",
    "emaileFilled": "O e-mail deve ser preenchido.  ",
    "titlUserNameDefinedNub": "O nome de usuário não pode exceder 30 caracteres  ",
    "titlRealNameNub": "O nome não pode exceder 30 caracteres.  ",
    "titlRealNameField": "O nome deve ser preenchido.  ",
    "thisPasswordField": "A senha deve ser preenchida.  ",
    "titlPassWordNub": "A senha deve ter entre 6 e 30 caracteres  ",
    "enableStatus": "Ativar usuário  ",
    "stopStatus": "Desativar usuário  ",
    "enableContent": "Tem certeza de que deseja ativar o(s) usuário(s)?  ",
    "stopContent": "Tem certeza de que deseja desativar o(s) usuário(s)?  ",
    "error1400": "O nome de usuário já existe, por favor tente novamente  ",
    "error1401": "O ID do usuário já existe e a operação falhou!  ",
    "error1402": "O grupo não existe, a importação falhou!  ",
    "error1403": "Dados incorretos  ",
    "error1404": "Permissões insuficientes  ",
    "selUser": "Por favor, selecione um usuário!  ",
    "error1405": "Falha ao obter função  ",
    "error1406": "O formato dos dados do usuário importado está incorreto  ",
    "error1407": "O e-mail já existe e a operação falhou.  ",
    "error1408": "O telefone já existe e a operação falhou.  ",
    "error1900": "O parâmetro acessado está vazio  ",
    "error1610": "Por favor, use a função de administrador de terminal para realizar operações relacionadas  ",
    "errorOrgIdList": "O grupo não pode estar vazio!  ",
    "Bindsucceeded": "Vinculação bem-sucedida  ",
    "Bindfailed": "Falha ao vincular  ",
    "tableuserName": "Nome de usuário  ",
    "titleDevice": "Dispositivo  ",
    "bindDevice": "Dispositivo vinculado  ",
    "Bindcontrollable": "Vincular dispositivo controlável agora?  "
  },
  "devicesMge": {
    mustChooseOne: 'Quando o controle remoto inteligente estiver selecionado, pelo menos um comando de controle deve ser escolhido',
    customName: 'Nome personalizado',
    "testAcCode": "Testar novo código de controle A/C",
    "Online": "Online",
    "Offline": "Offline",
    "unBindConfirm": "Confirmar para desvincular Serial",
    "unBindConfirm485": "Confirmar para desvincular RS485",
    "notYetBoundRS232": "O dispositivo ainda não está vinculado a um código Serial. Você pode ir em Dispositivo > Código de Controle Serial para adicioná-lo.",
    "RsFollowingFunctions": "Pode realizar as seguintes funções através dos códigos Serial:",
    "Unbind": "Desvincular",
    "Limit255": "O nome do arquivo contém no máximo 255 caracteres",
    "clear": "Limpar",
    "equipName": "Nome do dispositivo",
    "equipType": "Tipo",
    "selectField": "Selecione um arquivo",
    "dialogTip": "*Se a caixa de entrada à direita estiver vazia, o conteúdo à esquerda será exibido por padrão",
    "dialogTipSingle": "*Se um único dispositivo não for nomeado, siga o nome \"TODOS\"",
    "cantDelTemplateOne": "O CBX de",
    cantDelTemplateTwo: 'O CBX do dispositivo "{deviceName}" é um modelo. Tem certeza de que deseja excluí-lo?',
    "templateTitle": "Substituição de modelo",
    "templateContentOne": "O nome do dispositivo \"",
    "templateContentTwo": " foi configurado como o modelo CBX comum. Tem certeza de que deseja definir o dispositivo atual como modelo?",
    "vcbNoTemplateNoSave": "Não é possível salvar sem modelo",
    "vcbAcControl": "Selecione um dispositivo A/C",
    "vcbRemoteControl": "Selecione um dispositivo de controle remoto",
    "vcbPOWERControl": "Controle de energia",
    "vcbRS232Control": "Controle Serial",
    "vcbIRControl": "Controle IR",
    "vcbSetting": "Configuração CBX",
    "editVcb": "Editando CBX",
    "vcbName": "Nome do CBX",
    "iot": "Controle do CBX",
    "saveAsTemplate": "Salvar como modelo",
    saveAsTemplatereplenish: 'Selecione vários dispositivos para usar este modelo na Central de Controle',
    "Upload": "Carregar",
    "Select": "Selecionar",
    "InputDeviceID": "ID do dispositivo de entrada",
    "editNameTips": "* O conteúdo à esquerda é exibido por padrão quando a caixa de entrada à direita está vazia.",
    "_RS232A": "Interface um",
    "_RS232B": "Interface dois",
    "institutionDirectory": "Diretório da instituição",
    "projectionScreenLinkageSetting": "Configuração de controle da tela de projeção",
    "screenLiftingLinkageDisplaySwitch": "Controle de link entre a tela de projeção e a exibição:",
    "stopLinkage": "Desabilitar (Controlar a tela de projeção separadamente)",
    "Enable": "Habilitar (Controlar simultaneamente a tela de projeção e a exibição)",
    "btnAddDevice": "Adicionar dispositivo",
    "btnImportDevice": "Importação em massa de dispositivos",
    "btnDel": "Excluir",
    "btnEdit": "Editar",
    "tableIpAddress": "Endereço IP",
    "MACAddress": "Endereço MAC",
    "firmwareVersion": "Versão do firmware",
    "NA": "Não disponível",
    "tableDeviceName": "Nome do dispositivo",
    "tableStatus": "Status",
    "tableVideoSwitch": "Interruptor de vídeo",
    "tableAudio": "Distribuição A/V",
    "tablePowerControl": "Controle de energia",
    "tableRS232": "Controle serial",
    "tableIR": "Controle IR",
    "tableRFIDCard": "Cartão IC",
    "tableControlPanel": "Painel de controle",
    "tableOrganization": "Grupos",
    "tableActions": "Ações",
    "dialogAddTitle": "Adicionar dispositivo",
    "dialogEditTitle": "Editar dispositivo",
    "dialogBatchAddTitle": "Adicionar dispositivos em massa",
    "dialogBatchEditTitle": "Editar dispositivos em massa",
    "btnCancel": "Cancelar",
    "Devices": "Dispositivos:",
    "ProjectorCode": "Código Serial:",
    "Group": "Grupo:",
    "btnBatchAdd": "Adicionar em massa",
    "delTitle": "Excluir?",
    "delTitleContent": "Os componentes selecionados serão excluídos do banco de dados. Este processo é irreversível. Tem certeza de que deseja continuar?",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar",
    "addError": "Falha ao adicionar!",
    "editSuccess": "Edição bem-sucedida!",
    "editError": "Falha ao editar!",
    "delSuccess": "Exclusão bem-sucedida!",
    "delError": "Falha ao excluir!",
    "content": "Buscar",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Salvar",
    "tableDel": "Excluir",
    "tableEdit": "Editar",
    "selectRoles": "Selecionar funções",
    "selectType": "Por favor, selecione um tipo",
    "selectDevices": "Por favor, selecione um dispositivo",
    "titleRealNameRq": "Este campo deve ser preenchido",
    "titleRealNameNub": "Menos de 100 caracteres",
    "titlPassWordNub": "Menos de 15 caracteres",
    "error1900": "O parâmetro acessado está vazio",
    "error2000": "Número máximo de dispositivos conectáveis excedido",
    "error2001": "O código do dispositivo importado está incorreto ou ainda não foi inserido no sistema.",
    "error2002": "Nome do dispositivo duplicado importado",
    "error2003": "O ID do dispositivo importado já foi utilizado",
    "error2004": "Erro nos dados importados",
    "error2005": "O nome da marca ou do modelo está em duplicidade com os dados existentes no sistema; por favor, renomeie a marca ou o modelo.",
    "error2008": "Este dispositivo já está associado a outro grupo",
    "notDevicesName": "O nome do dispositivo não pode estar vazio",
    "notDevicesNO": "O ID do dispositivo não pode estar vazio",
    "dialogDevicesName": "Nome do dispositivo:",
    "dialogDevicesID": "ID do dispositivo:",
    "dialogProjectorCode": "Código Serial:",
    "dialogGroup": "Grupo:",
    "dialogSel": "Por favor escolha",
    "errorOrgIdList": "O grupo não pode estar vazio!",
    "errorDevicesName": "O nome do dispositivo não pode estar vazio!",
    "errorDevicesNo": "O ID do dispositivo não pode estar vazio!",
    "dialogTiltleDevices": "Dispositivos:",
    "uploadSuccess": "Upload bem-sucedido",
    "addSuccess": "Adicionar com sucesso",
    "ChooseGroups": "Escolher os grupos",
    "ChooseIcon": "Escolher ícone",
    "dialogDevicesTitle": "As configurações do parâmetro são aplicadas aos seguintes dispositivos",
    "backDevice": "Voltar",
    "bootSetting": "Opções de inicialização",
    "nmpOpenSetting": "Configurações de ligar",
    "npsOpenSetting": "Configurações de ligar",
    "nmpPowerSettings": "Configurações de energia",
    "npsPowerSettings": "Configurações de energia",
    "nmpInterfaceSettings": "Configurações de interface",
    "npsInterfaceSettings": "Configurações de interface",
    "nmpDefaultChannel": "Configurações do canal padrão",
    "nmpCloseSetting": "Configurações de desligamento",
    "npsCloseSetting": "Configurações de desligamento",
    "SwipeToStart": "Ativar bloqueio (toque no cartão para desbloquear)",
    "ControlPanelToStart": "Desativar bloqueio (operação ilimitada)",
    "Display": "Exibição",
    "External": "Externa",
    "startingUpMethod": "Ativar/desativar o bloqueio do painel:",
    "startWith": "Iniciar com:",
    "nmpstartWith": "Ligar sincronizado:",
    "nmpcloseWith": "Desligar sincronizado:",
    "RS232Tip": "Quando a alimentação principal é desligada, um total de 5 interfaces Serial, incluindo Serial e até 4 CBXs, receberão o código de comando de desligamento correspondente.",

    startPowerTip: 'Ao ligar, todos os dispositivos conectados às interfaces de energia do CBX são ativados.',
    startAirTip: 'Ao ligar, todos os aparelhos de ar-condicionado vinculados são ligados via infravermelho do dispositivo/CBX.',
    startIrTip: 'Ao ligar, um comando de integração é enviado via infravermelho do dispositivo/CBX (ex: tela desce, projetor liga).',
    startRSTip: 'Ao ligar, um comando de inicialização é enviado via interface Serial do dispositivo/CBX.',
    CloseDisplayTip: 'Dispositivos conectados à interface DISPLAY serão desligados automaticamente quando o NDP/NMP for desligado. Esta configuração é gerenciada pelo firmware e não pode ser alterada via software.',
    CloseExternalTip: 'Dispositivos conectados à interface EXTERNAL serão desligados automaticamente quando o NDP/NMP for desligado. Esta configuração é gerenciada pelo firmware e não pode ser alterada via software.',
    ClosePowerTip: 'Ao desligar, todos os dispositivos conectados às interfaces de energia do CBX são desativados.',
    CloseAirTip: 'Ao desligar, todos os aparelhos de ar-condicionado vinculados são desligados via infravermelho do dispositivo/CBX.',
    CloseIrTip: 'Ao desligar, um comando de integração é enviado via infravermelho do dispositivo/CBX (ex: tela sobe, projetor desliga).',
    CloseRSTip: 'Ao desligar, um comando de desligamento é enviado via interface Serial do dispositivo/CBX.',
    npsOpenRS232Tip: 'Quando a alimentação principal é ligada, as duas portas seriais do NPS receberão os códigos de comando de inicialização correspondentes.',
    "npsRS232Tip": "Quando a alimentação principal é desligada, as duas interfaces Serial do NPS receberão os códigos de comando de desligamento correspondentes.",
    "useCardTip": "Após desbloquear o cartão, a alimentação dos dispositivos será automaticamente ativada.",
    "npsCardTip": "Após desbloquear o cartão, a alimentação principal dos dispositivos será automaticamente ativada.",
    "PowerOutageHandling": "Manejo de falhas de energia",
    "PowerOutageHandTip": "Para continuar o acesso durante quedas de energia inesperadas, escolha 'Desbloquear em caso de falta de energia'. Caso contrário, selecione 'Bloquear em caso de falta de energia' para restringir o acesso.",
    "acSetting": "Configuração de A/C",
    "ChooseType": "Tipo de dispositivo",
    "ChooseBrand": "Escolher uma marca",
    "ChooseModel": "Escolher um modelo",
    "btnConnectingTest": "Teste de conexão",
    "LockSetting": "Configuração de fechadura elétrica",
    "ElectricLockType": "Tipo de fechadura elétrica:",
    "PowerUNLOCK": "Desbloquear em caso de falta de energia",
    "PowerLOCK": "Bloquear em caso de falta de energia",
    "none": "Nenhum",
    "oddParity": "Paridade ímpar",
    "EvenParity": "Paridade par",
    "LastSetting": "Última configuração",
    "ElectricLockClosing": "Fechamento da fechadura elétrica:",
    "manualSwitch": "Interruptor manual",
    "Auto": "Auto (em",
    "projectorSetting": "Seleção e vinculação de dispositivos",
    "baudRate": "Taxa de transmissão",
    "Parity": "Paridade",
    "ON": "Ligar",
    "OFF": "Desligar",
    "Channel1": "Canal 1",
    "Channel2": "Canal 2",
    "PowerOffDelay": "Atraso de desligamento",
    "second": "s",
    "DefaultChannel": "Canal padrão",
    "HDMIA": "HDMI saída A:",
    "HDMIB": "HDMI saída B:",
    "HDMIC": "HDMI saída C:",
    "btnSaveApply": "Salvar e aplicar a...",
    "btnSave": "Salvar",
    "btnCustomize": "Personalizado",
    "ACIsPowerTitle": "Verificar se o A/C está ligado?",
    "ACIsPowerContent": "Por favor, desligue o A/C antes de testar. Se não ligar corretamente, verifique se a marca e o modelo do A/C estão corretos.",
    "btnNextModel": "Não, testar o próximo modelo",
    "btnYes": "Sim",
    "errorConnecting": "Falha no teste de conexão",
    "hot": "QUENTE",
    "_MAGNETICLOCK": "Fechamento eletrônico",
    "_AIR": "Ar condicionado",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "Configurações de controle IR",
    "acControlTitle": "Selecione um dispositivo A/C:",
    "acControlTitleNew": "Dispositivo A/C",
    "intelligentControlTitle": "Selecione um dispositivo de controle remoto:",
    "intelligentControlTitleNew": "Dispositivo de controle remoto",
    "btnACControlCode": "Identificar o novo código de controle A/C",
    "btnAddRemoteControl": "Novo código de controle remoto",
    "ACControlCodeTitle": "Identificar o código de controle A/C",
    "ACControlCodeseft1": "Identificar código",
    "ACControlCodeseft2": "Adicionar informações",
    "btnStartIdentify": "Iniciar",
    "Identifysuccess": "Identificação bem-sucedida!",
    "BeingIdentify": "Analisando...",
    "acBrand": "Marca do A/C",
    "acModel": "Modelo do A/C",
    "IdentifyFailureTitle": "Falha ao encontrar o código",
    "IdentifyFailureContent": "A identificação falhou, este modelo não é suportado atualmente. Tente com o controle remoto",
    "btnTryAgain": "Tentar novamente",
    "btnJump": "Ir para o controle remoto",
    "ACrideo": "A/C",
    "ortherRideo": "Outros dispositivos",
    "btnBack": "Voltar",
    "btnSortOut": "Ir para editar",
    "remoteControlSeft1": "Selecionar tipo de dispositivo",
    "remoteControlSeft2": "Aprender código",
    "remoteControlSeft3": "Adicionar informações",
    "addRemoteControlError": "Desculpe, não é possível aprender mais códigos. Edite primeiro os códigos de controle remoto existentes",
    "btnPrevious": "Anterior",
    "btnNextStep": "Próximo",
    "remoteControlErrorTitle": "Falha ao aprender o código",
    "remoteControlErrorContent1": "1. O transmissor infravermelho não está bloqueado",
    "remoteControlErrorContent2": "2. Não há interferência de luz forte ao redor do receptor",
    "remoteControlErrorContent3": "3. O transmissor infravermelho está instalado corretamente",
    "remoteControlErrorContent4": "4. O controle remoto está funcionando bem",
    "deviceItem1": "A/C",
    "deviceItem2": "Projetor",
    "deviceItem3": "TV",
    "deviceItem4": "Ventilador",
    "deviceItem5": "Luz",
    "deviceItem6": "Outros",
    "deviceItem7": "Painel interativo",
    "deviceItem8": "Sistema de captura de palestras",
    "deviceItem9": "Câmera PTZ",
    "RS232protocol": "Protocolo Serial:",
    "btnRemoteControl": "Iniciar aprendizado",
    "BeingIdentify1": "Analisando...",
    "Identifysuccess1": "Sucesso",
    "controllerType1": "A/C",
    "controllerType2": "Serial",
    "controllerType3": "TV",
    "controllerType4": "Ventilador",
    "controllerType5": "Luz",
    "controllerType9": "Outros",
    "rqRemoteControlCode": "Por favor, insira o nome do código do controle remoto",
    "rqBrand": "Por favor, insira a marca do A/C",
    "rqModel": "Por favor, insira o modelo do A/C",
    "error2016": "O nome do controle remoto está duplicado, por favor insira outro",
    "RS232Setting": "Configuração do código serial",
    "IR232Setting": "Configuração IR",
    "SystemError": "Erro no sistema. Por favor, tente novamente",
    "conditionerCodeContent": "Não foi possível encontrar o código do ar condicionado, por favor, tente novamente",
    "remoteControlCodeContent": "Não foi possível encontrar o código do controle remoto, por favor, tente novamente",
    "btnRetry": "Tentar novamente",
    "Bindusers": "Vincular usuário",
    "tablebinduser": "Vincular usuários",
    "Refresh": "Atualizar",
    "Binduserlable": "Vincular usuários que podem controlar o dispositivo agora?",
    "SaveApplySuccessfully": "Salvar e aplicar com sucesso",
    "DeviceType": "Tipo:",
    "tableDeviceType": "Tipo",
    "empty": "Está vazio.",
    "sendCommand": "Enviar depois",
    "enable": "Habilitar",
    "disable": "Desabilitar",
    "SYNCremoteControl": "SINCRONIZAR com controle remoto",
    "analysisfailed": "A análise falhou, por favor, tente novamente",

    "CBX": {
      "powerSupplyON": "Ligar",
      "powerSupplyOFF": "Desligar",
      "powerVcrON": "Iniciar gravação",
      "powerVcrOFF": "Parar gravação",
      "lockScreenON": "Trancar",
      "lockScreenOFF": "Destrancar",
      "childLockON": "Bloqueio infantil ativado",
      "childLockOFF": "Bloqueio infantil desativado",
      "energySavingON": "Modo de economia de energia ativado",
      "energySaving": "Modo de economia de energia",
      "energySavingOFF": "Modo de economia de energia desativado",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "Alto-falante",
      "brightAdjustment": "Brilho",
      "other": "Outras funcionalidades...",
      "volumeExample": "Funcionalidade completa do Serial necessária para compatibilidade total com o sistema de gravação.",
      "functionCode": "Função:",
      "Name": "Nome:",
      "controlCode": "Código de controle:",
      "brand": "Marca:",
      "model": "Modelo:",
      "errorBrandName": "A marca não pode estar vazia!",
      "errorModelName": "O modelo não pode estar vazio!"
    }

  },
  "roleMge": {
    "role1": "Usuário geral",
    "role101": "Administrador de agente",
    "role102": "Administrador",
    "role4": "Função personalizada",
    "roleNew": "Novo papel",
    "btnAddRole": "Adicionar função",
    "chooseUser": "Escolher usuário",
    "titleLevel": "Nível de propriedade de transmissão:",
    "titleSettings": "Configurações de permissão:",
    "btnSave": "Salvar",
    "btnDelete": "Excluir",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Salvar",
    "addSuccess": "Adicionado com sucesso!",
    "addError": "Falha ao adicionar!",
    "editSuccess": "Editado com sucesso!",
    "editError": "Falha ao editar!",
    "delSuccess": "Excluído com sucesso!",
    "delError": "Falha ao excluir!",
    "V3_0_OrganizationManage": "Gerenciamento de grupos",
    "V3_0_UserManage": "Gerenciamento de usuários",
    "V3_0_DeviceManage": "Gerenciamento de dispositivos",
    "V3_0_CloudSpaceManage": "Gerenciamento de espaço em nuvem",
    "V3_0_OrganizationManage_View": "Visualizar",
    "V3_0_OrganizationManage_Edit": "Editar",
    "V3_0_UserManage_View": "Visualizar",
    "V3_0_UserManage_Edit": "Editar",
    "V3_0_DeviceManage_AddDevice": "Adicionar dispositivo",
    "V3_0_DeviceManage_Operating": "Operar",
    "V3_0_DeviceManage_Delete": "Excluir",
    "V3_0_DeviceManage_Edit": "Editar",
    "V3_0_CloudSpaceManage_PersonalManage": "Gestão de nuvem pessoal",
    "V3_0_CloudSpaceManage_PublicManage": "Gestão de nuvem pública",
    "V3_0_CloudSpaceManage_SpaceManage": "Alocação de espaço",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Operação",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Ver",
    "V3_0_CloudSpaceManage_PublicManage_View": "Ver",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Subir",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Baixar",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Excluir arquivo",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Editar pasta",
    "delTitle": "Excluir?",
    "delTitleContent": "O conteúdo selecionado será excluído do banco de dados. Esta operação não pode ser desfeita. Tem certeza de que deseja continuar?",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar",
    "btnAdd": "Adicionar papel",
    "RoleName": "Nome do papel:",
    "ManageRange": "Faixa de gestão:",
    "ChooseUser": "Escolher usuário:",
    "PermissionSettings": "Configurações de permissões:",
    "BroadcastingPropertyLevel": "Nível de propriedade de transmissão",
    "ChooseGroups": "Escolher grupos",
    "ChooseTheUser": "Escolher usuário",
    "deleleTitle": "O novo papel não foi salvo. Se sair, o papel será excluído. Tem certeza de que deseja sair?",
    "Error1601": "Não pode usar administrador",
    "Error1602": "Falha ao obter o papel de permissão",
    "Error1603": "Somente administradores têm acesso a essas funcionalidades",
    "Error1604": "O nome do papel não pode estar vazio",
    "Error1605": "O grupo não pode estar vazio",
    "Error1606": "Este papel já existe",
    "Error1607": "Papel definido pelo sistema, modificação não permitida",
    "Error1608": "Falha ao configurar o papel",
    "Error1609": "Papel de usuário comum do sistema, modificação não permitida",
    "Error1610": "Use o papel de administrador de terminal para realizar as operações associadas",
    "Error1611": "Não possui as permissões de papel relacionadas"
  },
  "projectorDevicesMge": {
    "tipOne": "1. Preencha o nome da função e o código de controle. Os exemplos de código de controle usam o formato HEX.",
    "tipTwo": "2. Esta interface é apenas para configuração de comandos seriais de ligar/desligar. Vá para 'Gerenciamento de dispositivos / Dispositivos / Operações / Configurações de energia' para habilitar a função.",
    "tipFunctionOne": "1. Selecione funções comuns na lista suspensa. Os ícones correspondentes serão exibidos na interface de controle serial do painel inteligente.",
    "tipFunctionTwo": "2. Os comandos 'POWER ON' e 'POWER OFF' são usados para vinculação serial de ligar/desligar do dispositivo. Esta página apenas configura códigos de controle. Vá para 'Gerenciamento de dispositivos / Dispositivos / Operações / Configurações de energia' para habilitar a função de vinculação.",
    "ListRS232functions": "Lista de funções de controle serial",
    "Customizefunctionlist": "Personalizar a lista de funções",
    "btnAddProjectorCode": "Adicionar código serial",
    "btnDel": "Excluir",
    "inputSeach": "Pesquisar",
    "btnEdit": "Editar",
    "cancel": "Limpar",
    "confirm": "Confirmar",
    "tableName": "Nome do código",
    "tablersType": "Tipo de dispositivo:",
    "tablersTypeTable": "Tipo de dispositivo",
    "tableModel": "Modelo",
    "tableBrand": "Marca",
    "tableActions": "Ações",
    "dialogAddTitle": "Adicionar código Serial",
    "dialogEditTitle": "Editar código Serial",
    "brand": "Nome da marca:",
    "model": "Modelo:",
    "baudRate": "Taxa de transmissão:",
    "parity": "Paridade:",
    "powerOn": "LIGADO",
    "powerOff": "DESLIGADO",
    "pgrInput1": "Canal 1",
    "pgbInput2": "Canal 2",
    "delTitle": "Excluir?",
    "delTitleContent": "O conteúdo selecionado será excluído do banco de dados. Esta operação não pode ser desfeita. Tem certeza de que deseja continuar?",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar",
    "content": "Pesquisar",
    "operate": "Ações",
    "tableDel": "Excluir",
    "tableEdit": "Editar",
    "addSuccess": "Adicionado com sucesso!",
    "addError": "Falha ao adicionar!",
    "editSuccess": "Editado com sucesso!",
    "editError": "Falha ao editar!",
    "delSuccess": "Excluído com sucesso!",
    "delError": "Falha ao excluir!",
    "selectTitle": "Por favor, selecione um Serial!",
    "selectCode": "Selecionar Serial",
    "none": "Nenhum",
    "oddParity": "Paridade ímpar",
    "EvenParity": "Paridade par"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "Gerenciamento de grupos",
    "V3_0_UserManage": "Gerenciamento de usuários",
    "V3_0_DeviceManage": "Gerenciamento de dispositivos",
    "V3_0_CloudSpaceManage": "Gerenciamento de espaço em nuvem",
    "V3_0_OrganizationManage_View": "Ver",
    "V3_0_OrganizationManage_Edit": "Editar",
    "V3_0_UserManage_View": "Ver",
    "V3_0_UserManage_Edit": "Editar",
    "V3_0_DeviceManage_AddDevice": "Adicionar dispositivo",
    "V3_0_DeviceManage_Operating": "Operar",
    "V3_0_DeviceManage_Delete": "Excluir",
    "V3_0_DeviceManage_Edit": "Editar",
    "V3_0_DeviceManage_RepairLog": "Registro de reparo",
    "V3_0_CloudSpaceManage_PersonalManage": "Gerenciamento de nuvem pessoal",
    "V3_0_CloudSpaceManage_PublicManage": "Gerenciamento de nuvem pública",
    "V3_0_CloudSpaceManage_SpaceManage": "Gerenciamento de espaço em nuvem",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Operar",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Ver",
    "V3_0_CloudSpaceManage_PublicManage_View": "Ver",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Carregar",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Baixar",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Excluir",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Editar",
    "delTitle": "Excluir?",
    "delTitleContent": "Os componentes selecionados serão excluídos do banco de dados. Este processo é irreversível. Tem certeza de que deseja continuar?",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar",
    "content": "Pesquisar",
    "operate": "Ação",
    "tableDel": "Excluir",
    "tableEdit": "Editar",
    "addSuccess": "Adicionado com sucesso!",
    "addError": "Falha ao adicionar!",
    "editSuccess": "Editado com sucesso!",
    "editError": "Falha ao editar!",
    "delSuccess": "Excluído com sucesso!",
    "delError": "Falha ao excluir!",
    "selectTitle": "Selecione Serial!"
  },
  "workstationMge": {
    "priorChoice": "Preferência de transmissão:",
    "SpeedPriority": "Prioridade de velocidade",
    "SyncPriority": "Prioridade de sincronização de quadro",
    "SpeedPriorityTip": "Após o envio das instruções de transmissão AV, os terminais Q-NEX podem realizar a tarefa de reprodução em um tempo de buffer mais curto, cerca de 3-5 segundos. A prioridade de velocidade é altamente recomendada quando o servidor de mídia funciona na LAN.",
    "SyncPriorityTip": "Após o envio das instruções de transmissão AV, os terminais Q-NEX podem realizar a tarefa de reprodução de forma sincronizada com um tempo de buffer de cerca de 8-12 segundos.",
    "btnAddMedia": "Adicionar servidor de mídia",
    "btnBack": "Voltar",
    "tableMediaLibId": "ID do servidor de mídia",
    "tableMediaLibName": "Nome do servidor de mídia",
    "tableState": "Status da rede",
    "tableBindingUsers": "Usuários vinculados",
    "tableLiveAddress": "Endereço de transmissão",
    "tableAddress": "Endereço de streaming",
    "tableOperate": "Ações",
    "tableDel": "Excluir",
    "tableEdit": "Editar",
    "titleMediaStation": "Endereço de transmissão",
    "titleLiveStation": "Endereço de streaming:",
    "radioPublic": "Público",
    "radioPrivate": "Privado",
    "btnSave": "Salvar",
    "titleUsers": "Usuários",
    "titleCanBe": "Pode ser vinculado",
    "titleHaveBeen": "Já vinculado",
    "titleMore": "Precisa adicionar mais?",
    "btnAdd": "Adicionar",
    "content": "Buscar",
    "tableName": "Nome",
    "tableUserName": "Nome de usuário",
    "operate": "Ações",
    "affiliatedOrganization": "Grupos",
    "dialogTitle": "Adicionar novo servidor de mídia",
    "dialogTitleEdit": "Editar novo servidor de mídia",
    "dialogItemName": "Nome:",
    "dialogItemId": "ID:",
    "dialogItemIp": "Endereço de difusão:",
    "titleSelectUsers": "Selecionar usuários",
    "selectMedia": "Por favor, escolha a mídia",
    "delTitle": "Tem certeza de que deseja excluir?",
    "delMediaLibTitle": "Confirmação de exclusão?",
    "delTitleContent": "Os conteúdos selecionados serão excluídos do banco de dados. Esta operação não pode ser desfeita. Tem certeza de que deseja continuar?",
    "delTitleMediaLibContent": "A ação de exclusão causará a exclusão dos dados relevantes e não pode ser revertida.",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar",
    "selectDevices": "Por favor, selecione dispositivos",
    "selectUser": "Por favor, selecione usuários",
    "addUser": "Adicionar usuário",
    "editUser": "Editar usuário",
    "addSuccess": "Adicionado com sucesso!",
    "addError": "Falha ao adicionar!",
    "editSuccess": "Editado com sucesso!",
    "editError": "Falha ao editar!",
    "delSuccess": "Excluído com sucesso!",
    "delError": "Falha ao excluir!",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Salvar",
    "error2500": "Número máximo de dispositivos que podem ser conectados à estação de trabalho atual excedido.",
    "DeviceName": "Nome do dispositivo",
    "AssociatedUserManagement": "Gestão de usuários associados",
    "btnDel": "Excluir",
    "errorMsgId": "Não é possível encontrar este ID",
    "LiveStreaming": "Endereço de streaming:",
    "NoFoundMediaId": "Não é possível obter o ID do servidor de mídia",
    "AlreadyConnectedOrg": "O servidor de mídia já está associado a outra organização",
    "AlreadyBoundMedia": "Esta organização já vinculou um servidor de mídia e não pode vincular outro",
    "DeleteSecondaryConfirmation": "Os dados não podem ser recuperados após a exclusão do servidor de mídia, por favor, confirme novamente."
  },
  "cloudDiskMge": {
    "totalStorage": "ARMAZENAMENTO TOTAL",
    "GetMore": "Obter mais",
    "StorageSpace": "Espaço de armazenamento",
    "Adjustment": "Ajuste",
    "moreSpace": "Obter mais espaço de armazenamento",
    "PublicStorage": "Armazenamento público",
    "PublicStorageUsed": "Armazenamento público usado",
    "PublicStorageLasted": "Armazenamento público restante",
    "IndividualStorageUsed": "Armazenamento pessoal usado",
    "IndividualStorageLasted": "Armazenamento pessoal restante",
    "storageSpace": "Ajuste de espaço de armazenamento",
    "tableUserName": "Nome de usuário",
    "tableUsedSpace": "Espaço usado",
    "tableAvailableSpace": "Espaço disponível",
    "tableActiveTime": "Última hora ativa",
    "tableOperate": "Ações",
    "cleanup": "Nota para limpeza",
    "IndividualStorageSpaceAdjustment": "Ajuste de espaço de armazenamento pessoal",
    "titleTotal": "Total",
    "PublicDisk": "Nuvem pública",
    "IndividualDisk": "Nuvem pessoal",
    "PerUser": "Por usuário",
    "UsersInTotal": "Total de usuários",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Salvar",
    "addSuccess": "Adicionado com sucesso!",
    "addError": "Falha ao adicionar!",
    "editSuccess": "Edição bem-sucedida!",
    "editError": "Falha ao editar!",
    "delSuccess": "Excluído com sucesso!",
    "delError": "Falha ao excluir!",
    "error3000": "A operação falhou porque o tamanho total do armazenamento foi excedido.",
    "error3003": "Operação falhou, verifique se um servidor de mídia foi configurado.",
    "IndividualStorage": "Armazenamento pessoal",
    "NoteToCleanup": "Nota para limpeza",
    "updatePersonalSuccess": "Seu espaço de armazenamento na nuvem ficará cheio, por favor limpe a tempo",
    "updatePersonalSuccess1": "Modificado e salvo com sucesso",
    "storageUsage": "Uso do armazenamento pessoal",
    "bindIndividualstorage": "Usuários permitidos para ter armazenamento em nuvem pessoal",
    "UserIndividualstorage": "Usuários já configuraram armazenamento em nuvem pessoal",
    "Notificationsuccessfully": "Notificação enviada com sucesso",
    "Notificationfailed": "Falha ao enviar a notificação",
    "tableName": "Nome",
    "userID": "ID do usuário"
  },
  "dashboard": {
    "exportPdf": "Exportar PDF",
    "or": "-",
    "warrantyCompletionRate": "Taxa de reparação",
    "frequencyOfEachModule": "A porcentagem de reparo de cada módulo funcional",
    "repairHandling": "Status de processamento do reparo",
    "sourceSwitchInput": "Interruptor de entrada",
    "micVol": "Volume do microfone",
    "volumeSpeaker": "Volume do alto-falante",
    "airAonditioner": "Ar condicionado",
    "Curtain": "Tela do projetor",
    "remoteControlIntelligent": "Controle remoto",
    "RS232Control": "Controle Serial",
    "lockElectronic": "Fechaduras eletrônicas",
    "Repairreportcompleted": "Reparado",
    "Totalnumberofrepairsreported": "Total de reparos",
    "Warrantycompletionrate": "Taxa de conclusão do reparo",
    "startDate": "Data de início",
    "endDate": "Data de término",
    "year": "Ano",
    "month": "Mês",
    "dayTian": "Dia",
    "placeholderDate": "Selecionar data",
    "placeholderDateTime": "Selecionar hora",
    "devicesNub": "Dispositivos",
    "userNub": "Usuários",
    "powerNub": "Potência (KW/H)",
    "storageUsed": "Armazenamento utilizado (%)",
    "userLoginDevice": "Período de tempo ativo de login do usuário",
    "devicePowerConsumption": "Consumo diário de eletricidade de todos os dispositivos",
    "externalDeviceUsageTime": "Uso de dispositivos externos",
    "equipmentRunningTime": "Uso de dispositivos terminais",
    "cloudStorageSpace": "Uso de armazenamento",
    "powerConsumptionPort": "Consumo de energia de cada porta de alimentação",
    "mostPopularFile": "Arquivo mais popular",
    "commonFunctions": "Funções comuns",
    "commonlyUsed": "Método de transmissão mais comum",
    "fileName": "Nome do arquivo",
    "usageCount": "Contagem de uso",
    "electricityConsumption": "Consumo de eletricidade",
    "publicStorageUsed": "Armazenamento público utilizado",
    "publicStorageLasted": "Armazenamento público restante",
    "individualStorageUsed": "Armazenamento individual utilizado",
    "individualStorageLasted": "Armazenamento individual restante",
    "notification": "Notificação",
    "audioBroadcast": "Transmissão de áudio",
    "videoBroadcast": "Transmissão de vídeo",
    "ac": "Ar condicionado",
    "hDMISwitch": "Interruptor HDMI",
    "powerControl": "Controle de energia",
    "powercontrol": "Controle de energia",
    "Lock": "Bloquear",
    "volumeAdjust": "Ajuste de volume",
    "projectionScreen": "Tela de projeção",
    "today": "Hoje",
    "yesterday": "Ontem",
    "thisWeek": "Esta semana",
    "lastWeek": "Semana passada",
    "lastMonth": "Mês passado",
    "thisMonth": "Este mês",
    "times": "Vezes",
    "usage": "Contagem de uso",
    "eachrTitle": "Minutos",
    "total": "Total",
    "NMPSystemissue": "Problema do sistema NMP",
    "displayPower": "Problema do dispositivo externo NMP",
    "externalPower": "Problema do sistema MBX",
    "screen": "Problema do dispositivo externo MBX",
    "TotalRepairs": "Total de reparos",
    "Repaired": "Reparado",
    "Unrepaired": "Não reparado",
    "day": "DIA",
    "Minutes": "Minutos",
    "powerConsumption": "Minutos",
    "Date": "Data",
    "kw": "KW",
    "month1": "SEG",
    "month2": "TER",
    "month3": "QUA",
    "month4": "QUI",
    "month5": "SEX",
    "month6": "SÁB",
    "month7": "DOM",
    "enmonth1": "Jan",
    "enmonth2": "Fev",
    "enmonth3": "Mar",
    "enmonth4": "Abr",
    "enmonth5": "Mai",
    "enmonth6": "Jun",
    "enmonth7": "Jul",
    "enmonth8": "Ago",
    "enmonth9": "Set",
    "enmonth10": "Out",
    "enmonth11": "Nov",
    "enmonth12": "Dez",
    "noData": "Sem dados"
  },
  "input": {
    "fivedigits": "Por favor, insira um número inteiro positivo de 5 dígitos",
    "titlUserNameField": "Este nome de usuário deve ser preenchido",
    "thisField": "Este campo deve ser preenchido",
    "ChooseGroup": "Escolher grupo",
    "placeholder": "Selecionar",
    "placeholder_type": "Por favor, selecione os tipos de controle de dispositivo",
    "titlRealNameField": "A senha deve ser preenchida",
    "thisPasswordField": "A senha deve ser preenchida",
    "titlPassWordNub": "Menos de 15 letras",
    "Post": "Somente números",
    "passwordNoChinese": "Esta caixa de entrada não pode ser preenchida com caracteres chineses"
  },
  "transfer": {
    "all": "Tudo",
    "Choose": "Escolher",
    "Selected": "Selecionado",
    "Subordinate": "Subordinado"
  },
  "setting": {
    limitPngGif: 'Apenas formatos PNG / GIF são suportados',
    limit3M: 'O tamanho da imagem não pode exceder 3 MB',
    setting_door_Wallpaper_text: 'Tamanho de imagem recomendado: 1280x800, formato PNG ou GIF',

    "reduction": "Restaurar",
    "limitJpg": "A imagem do perfil carregada só pode estar no formato PNG!",
    "limit2M": "O tamanho da imagem do perfil carregada não pode exceder 2 MB!",
    "choseFile": "Selecionar arquivo",
    "textOne": "1. Imagem LOGO recomendada: tamanho 117*40, no formato PNG",
    "textTwo": "2. Após o upload, por favor vá para o Painel Touch, certifique-se de que o Painel Touch está conectado à Internet e clique no logo original para atualizar.",
    "customizeLogo": "Configuração do logo do Painel Touch",
    "addSuccess": "Configuração bem-sucedida!",
    "settingIp": "Configuração de endereço IP de armazenamento de arquivos",
    "ServerIP": "Endereço IP do servidor:",
    "ServerPort": "Porta do servidor:",
    "btnSave": "Salvar",
    "TimeZoneSetting": "Configuração de fuso horário",
    "CurrentTime": "Hora atual:",
    "CurrentTimeZone": "Fuso horário atual:",
    "httpsSetting": "Armazenamento de arquivos:",
    "utcName": "Hora Média de Greenwich UTC/GMT",
    "utc0": "Hora Média de Greenwich, Reino Unido, Lisboa, Torshavn, Londres, Dublin, Edimburgo",
    "utc0_5": "",
    "utc1": "Europa Central, África Ocidental, África Central Ocidental, Alemanha, Irlanda, França, Amsterdã, Itália, Berlim, Roma, Espanha, Praga, Belgrado, Bruxelas, Paris, Madrid, Tunísia, Gabão, Marrocos",
    "utc1_5": "",
    "utc2": "Europa Oriental, África Central, Turquia, Israel, África do Sul, Istambul, Cairo, Atenas, Damasco",
    "utc2_5": "",
    "utc3": "África Oriental, Rússia, Bagdá, Kuwait, Moscou, São Petersburgo",
    "utc3_5": "Irã",
    "utc4": "Abu Dhabi, Tbilisi, Dubai, Maurício, Port Louis",
    "utc4_5": "Afeganistão",
    "utc5": "Paquistão, Turcomenistão, Maldivas, Uzbequistão, Armênia, Tajiquistão Índia, Mumbai, Nova Délhi, Bangalore, Calcutá",
    "utc5_5": "Índia, Sri Lanka",
    "utc6": "Novosibirque, Quirguistão, Bangladesh, Butão",
    "utc6_5": "Ilhas Cocos Austrália, Vietnã",
    "utc7": "Tailândia, Bangkok, Hanói, Jacarta",
    "utc7_5": "",
    "utc8": "China, Malásia, Filipinas, Cingapura, Taiwan China, Macau China, Hong Kong China",
    "utc8_5": "",
    "utc9": "Japão, Coreia do Sul, Tóquio, Seul, Sapporo, Osaka, Timor-Leste",
    "utc9_5": "Hora padrão central australiana",
    "utc10": "Austrália, Vladivostok, Guam, Canberra, Melbourne, Sydney, Papua Nova Guiné",
    "utc10_5": "Ilha Lord Howe de Nova Gales do Sul, Austrália",
    "utc11": "Ilhas Salomão, Ilha Sakhalin",
    "utc11_5": "Ilha Norfolk, Austrália",
    "utc12": "Nova Zelândia, Auckland, Wellington, Fiji, Nova Zelândia, Nauru",
    "utc12_5": "",
    "utc13": "Cabo Verde, Açores",
    "utc13_5": "",
    "utc14": "Geórgia do Sul, Fernando de Noronha",
    "utc14_5": "",
    "utc15": "Brasil, Santiago, El Salvador, Brasília, Uruguai, Argentina, Suriname",
    "utc15_5": "Hora padrão de Terra Nova",
    "utc16": "Venezuela, Bolívia, Paraguai, Chile",
    "utc16_5": "Venezuela",
    "utc17": "Hora do Leste (EUA e Canadá), Colômbia, Toronto, Equador, Peru, Cuba, Nova York, Hamilton, San Diego",
    "utc17_5": "",
    "utc18": "Hora central dos EUA e do Canadá, Cidade do México, Monterrey, Chicago, Houston, Nova Orleans, Memphis",
    "utc18_5": "",
    "utc19": "Hora das Montanhas, Arizona, Mazatlán, Phoenix, Salt Lake City, Denver, Edmonton",
    "utc19_5": "",
    "utc20": "Hora do Pacífico, Los Angeles, São Francisco, Vancouver, Seattle, Las Vegas",
    "utc20_5": "",
    "utc21": "Alasca",
    "utc21_5": "Polinésia Francesa, Ilhas Marquesas",
    "utc22": "Havai",
    "utc22_5": "",
    "utc23": "Samoa, Niue",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "Nome do dispositivo:",
    "Time": "Hora:",
    "startDate": "Data de início",
    "endedDate": "Data de término",
    "or": "-",
    "Problem": "Problema:",
    "btnSearch": "Pesquisar",
    "tableNO": "Não",
    "tableDeviceName": "Nome do dispositivo",
    "tableGroup": "Grupo",
    "tableStatus": "Status",
    "tableDeliveredTime": "Hora de entrega",
    "tableSubmitter": "Submissor",
    "tableUpdatingTime": "Hora de atualização",
    "tableProblem": "Problema",
    "tableAdmin": "IT-Admin",
    "tableAdminReply": "Resposta do Admin",
    "tableAttachment": "Anexo",
    "state0": "Entregue",
    "state1": "Em andamento",
    "state2": "Concluído",
    "Problem100": "TODOS",
    "Problem0": "Problema do sistema",
    "Problem1": "Problema de dispositivo externo",
    "ProblemType": "",
    "ProblemType0": "Controle de energia",
    "ProblemType1": "Interruptor HDMI",
    "ProblemType2": "Microfone",
    "ProblemType3": "Alto-falante",
    "ProblemType4": "Ar condicionado",
    "ProblemType5": "Tela do projetor",
    "ProblemType6": "Fechadura elétrica",
    "ProblemType7": "Transmissão A/V",
    "ProblemType8": "Controle IR",
    "ProblemType9": "Controle Serial",
    "dialogDeviceName": "Nome do dispositivo",
    "dialogDeviceID": "ID do dispositivo",
    "dialogGroup": "Grupo",
    "dialogSubmitter": "Submissor",
    "dialogStatus": "Escolha o status",
    "dialogProblem": "Problema",
    "dialogNotes": "Notas",
    "dialogRepairation": "Reparação",
    "dialogInProcess": "Em andamento",
    "dialogCompleted": "Concluído",
    "editSuccess": "Edição bem-sucedida!",
    "editError": "Falha ao editar!",
    "problemRequired": "Por favor, selecione um tipo de problema",
    "detailRequired": "Descreva o problema em detalhes",
    "statusRequired": "Escolha o status do log",
    "btnCancel": "Cancelar",
    "DeliveredTime": "Hora de entrega",
    "UpdatingTime": "Hora de atualização",
    "ITAdmin": "IT-Admin",
    "AdminReply": "Resposta do Admin",
    "Note": "Nota",
    "Detail": "Detalhes",
    "controlPanel": "Painel de controle",
    "DeviceType": "Tipo",
    "dialogDeliveredTime": "Hora de entrega",
    "Submitter": "Submissor"
  },
  "remoteControl": {
    "QuickActionName": "Nome",
    "DeviceType": "Tipo",
    "Description": "Descrição",
    "tableDescription": "Descrição",
    "editRemoteControl": "Editar código de controle remoto",
    "QuickActionNameInput": "Nome",
    "DescriptionInput": "Descrição",
    "save": "Salvar",
    "Brand": "Marca",
    "Model": "Modelo",
    "EditACControlCode": "Editar código de controle de A/C",
    "acBrand": "Marca do A/C",
    "acModel": "Modelo do A/C"
  },
  "card": {
    "btnAddCard": "Adicionar cartão",
    "btnBatchAddCard": "Adicionar cartões em lote",
    "tableCard": "Número do cartão",
    "tableState": "Status",
    "tableUser": "Usuário vinculado",
    "tableID": "Nome de usuário",
    "tableType": "Tipo de cartão",
    "tableFfective": "Data de expiração",
    "dialogCard": "Número do cartão :",
    "dialogState": "Status :",
    "dialogUser": "Usuário vinculado :",
    "dialogID": "Nome de usuário:",
    "dialogType": "Tipo de cartão :",
    "dialogFfective": "Data de expiração :",
    "dialogRemarks": "Observações :",
    "dialogAddTitle": "Adicionar cartão",
    "dialogEidtTitle": "Editar cartão",
    "code2201": "O formato do período de validade do cartão está incorreto",
    "code2202": "Este cartão já está vinculado",
    "code2203": "Este usuário já está vinculado",
    "code2204": "Este cartão não está vinculado",
    "mastCard": "Cartão mestre",
    "regularCard": "Cartão geral",
    "permanent": "Permanente",
    "coxPermanent": "Permanente",
    "coxTime": "Período determinado",
    "tableDeviceName": "Nome do dispositivo",
    "tableDeviceID": "ID do dispositivo",
    "tableOperating": "Operação",
    "tableOperatingTime": "Tempo de operação",
    "tableCardID": "Número do cartão",
    "tableCardType": "Tipo de cartão",
    "tabluserName": "Nome de usuário",
    "tabluserId": "ID de usuário",
    "unlockPanel": "Desbloquear painel",
    "unlock": "Desbloquear porta",
    "conAll": "Tudo",
    "btnEnable": "Habilitar",
    "btnDisable": "Desabilitar",
    "enableSuccess": "Habilitado com sucesso",
    "stopSuccess": "Desabilitado com sucesso",
    "enableError": "Falha ao habilitar",
    "stopError": "Falha ao desabilitar",
    "batchCard": "Número de cartão em lote :",
    "titlCardField": "O número do cartão não pode estar vazio",
    "titlCardFieldFormat": "Somente letras e números",
    "dialogBachAddTitle": "Adicionar cartões em lote",
    "pleaseTryAgain1": "Número do cartão incorreto (NO. :",
    "pleaseTryAgain2": "), por favor, tente novamente"
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/pt.js